import { api } from "../APIClient";
import { ACTION_TYPE } from "reducers/actionType";
import { hydrateUserSubjects } from "utils/helpers";
import { groupRecommendations } from "actions/recommendationsActions";

const ENDPOINT_PATH_1 = "/service/stage/1/hydrate";
const ENDPOINT_PATH_2 = "/service/stage/2/hydrate";

export const hydrateRecommendations = (recommendations_input_hash) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.recommendationsFetch.begin,
      data: { recommendations: [], loading: true },
    });
    return api
      .get(
        ENDPOINT_PATH_1 +
          "?recommendations_input_hash=" +
          recommendations_input_hash
      )
      .then((response) => {
        const { input, output } = response.data;

        /******************** Input Hash ***************/

        const {
          careers,
          courses,
          interests,
          personality_attributes,
          skills,
        } = input;
        dispatch({
          type: ACTION_TYPE.CAREER.PICK,
          data: careers.map((ob) => ob.id.toString()),
        });
        dispatch({
          type: ACTION_TYPE.INTEREST.PICK,
          data: interests.map((ob) => ob.id.toString()),
        });

        dispatch({
          type: ACTION_TYPE.SKILL.PICK,
          data: skills.map((ob) => ob.id.toString()),
        });

        dispatch({
          type: ACTION_TYPE.PERSONALITY.PICK,
          data: personality_attributes,
        });

        const allCourses = [];
        courses.institutions.forEach((inst) => {
          inst.course_codes.forEach((code) => {
            allCourses.push(code.toString());
          });
        });

        dispatch({
          type: ACTION_TYPE.COURSE.PICK,
          data: allCourses,
        });

        // Update Recommendations
        const { recommendations } = output; // recommendations, recommendatoins input hash
        dispatch(groupRecommendations(recommendations));

        dispatch({
          type: ACTION_TYPE.recommendationsFetch.success,
          data: { recommendations: recommendations, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: ACTION_TYPE.recommendationsFetch.failure,
          data: { error: error.response, loading: false },
        });
      });
  };
};

export const hydrateEligibility = (
  recommendations_input_hash,
  eligibility_input_hash
) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.eligibilityFetch.begin,
      data: { eligibility: null, loading: true },
    });

    let appendage = `?=eligibility_input_hash=${eligibility_input_hash}`;

    if (recommendations_input_hash) {
      appendage += `&recommendations_input_hash=${recommendations_input_hash}`;
    }

    return api
      .get(ENDPOINT_PATH_2 + appendage)
      .then((response) => {
        dispatch({
          type: ACTION_TYPE.eligibilityFetch.begin,
          data: { eligibility: response.data.output, loading: false },
        });

        const { subjects } = response.data.input;
        const userSubjects = subjects.map((sub) => sub.toString());
        dispatch(hydrateUserSubjects(userSubjects));
      })

      .catch((error) => {
        dispatch({
          type: ACTION_TYPE.eligibilityFetch.failure,
          data: { error: error, loading: false },
        });
      });
  };
};
